import { applyFieldLogic } from './apply-field-logic';
import { buildBannerType } from './build-banner-type';
import { cleanFormData } from './clean-form-data';
import { getDynamicOptions } from './get-dynamic-options';
import { getBannerMetadata } from '../../vs-unified/helpers';

export const getPlayerVsPlayerHelpers = () => ({
  buildBannerType,
  getDynamicOptions,
  cleanFormData,
  applyFieldLogic,
  getBannerMetadata
});
